import React from 'react';
import { Badge } from '../components/ui/badge';
import { CheckCircle2, AlertCircle, XCircle, RefreshCw, ShieldQuestion } from 'lucide-react';

export const getStageBadge = (stage) => {
    switch (stage) {
        case 'LEAD': return <Badge variant="secondary">Lead</Badge>;
        case 'CONTACTED': return <Badge className="bg-blue-500 hover:bg-blue-600">Contacted</Badge>;
        case 'REPLIED': return <Badge className="bg-green-500 hover:bg-green-600">Replied</Badge>;
        case 'MEETING_BOOKED': return <Badge className="bg-purple-500 hover:bg-purple-600">Meeting</Badge>;
        case 'CLOSED_WON': return <Badge className="bg-emerald-600 hover:bg-emerald-700">Won</Badge>;
        case 'CLOSED_LOST': return <Badge variant="destructive">Lost</Badge>;
        case 'UNQUALIFIED': return <Badge variant="outline">Unqualified</Badge>;
        default: return <Badge variant="outline">{stage}</Badge>;
    }
};

export const getVerificationIcon = (status) => {
    switch (status) {
        case 'VERIFIED': return <CheckCircle2 className="w-4 h-4 text-green-500 inline mr-1" />;
        case 'RISKY': return <AlertCircle className="w-4 h-4 text-amber-500 inline mr-1" />;
        case 'INVALID': return <XCircle className="w-4 h-4 text-red-500 inline mr-1" />;
        case 'VERIFYING': return <RefreshCw className="w-4 h-4 text-blue-500 inline mr-1 animate-spin" />;
        case 'UNKNOWN':
        default: return <ShieldQuestion className="w-4 h-4 text-slate-400 inline mr-1" />;
    }
};
